module.exports = __webpack_public_path__ + "img/training-pic1.cc819c68.png";